import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import apiAgent from "../../../app/api/apiAgent";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { CreditResponseModel } from "../../../app/models/CreditResponseModel";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import AgentCreditBox from "./AgentCreditBox";
import AjaxLoader from "../../../app/common/common-components/AjaxLoader";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function CreditPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [credit, setCredit] = useState<CreditResponseModel>();
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  useEffect(() => {
    setIsLoading(true);
    apiAgent.Admin.getCredit()
      .then((response: CreditResponseModel) => {
        let oCredit: CreditResponseModel = response;
        setCredit(oCredit);
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  document.title = "Base - Credit";

  if (isLoading) {
    return <AjaxLoader />;
  } else if (!isLoading && credit) {
    return (
      <>
        <div className="container-fluid">
          <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Credit" }]} />

          <div className="row">
            <div className="hidden-sm col-md-2"></div>
            <div id="content" className="col-sm-12 col-md-8">
              <AgentCreditBox officeDD={credit.officeDD} />
            </div>
            <div className="hidden-sm col-md-2"></div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
});
